import { render, staticRenderFns } from "./RefundCreateTermsModal.vue?vue&type=template&id=0b45b1fb&"
import script from "./RefundCreateTermsModal.vue?vue&type=script&lang=js&"
export * from "./RefundCreateTermsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports